export default "__VITE_PUBLIC_ASSET__d8b71456__"